import { mutations as types } from "./types";
import { FETCH } from "@/utils/list.js";

let comparer = (obj, item) => {
  return obj.id === item.id;
};


const mutations = {
  [types.GROUP_FETCH_LIST]: (state, { pageType, groups }) => {
    FETCH(state[pageType].groups, groups, comparer, null);
  },
  [types.GROUP_ADD_PAGES]: (state, group_id, pages) => {
    let group = state.groups.find(e => e.id == group_id)
    if (group) {
      group.pages = pages;
    }
  },
  [types.GROUP_UPDATE]: (state, { pageType, groupUpdated }) => {
    let group = state[pageType].groups.find(e => e.id == groupUpdated.id);
    if (group) {
      group.name = groupUpdated.name
    }
  },
  [types.GROUP_DELETE]: (state, { group_id, pageType }) => {
    let indexFound = state[pageType].groups.findIndex(e => {
      return e.id == group_id;
    });

    if (indexFound >= 0) {
      state[pageType].groups.splice(indexFound, 1);
    }
  }
};

export default mutations;
